import { Route } from 'react-router';

import Performance from './performance';
import MainLayout from '../../layouts/MainLayout';
import React from 'react';
import RequireAuth from '../../guards/RequireAuth';

const Routes = (
  <Route
    path="/analytics"
    element={
      <RequireAuth>
        <MainLayout />
      </RequireAuth>
    }
  >
    <Route path="/analytics/performance" element={<Performance />} />
  </Route>
);

export default Routes;
